import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ErrorMessageDirective } from '../../../directives/error-message.directive';
import { MiscModule } from '../../../misc.module';
import { SavePageRoutingModule } from './save-routing.module';
import { SavePageComponent } from './save.component';

@NgModule({
  declarations: [SavePageComponent],
  imports: [SavePageRoutingModule, IonicModule, ReactiveFormsModule, MiscModule, ErrorMessageDirective]
})
export class SavePageModule {}
